import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import ETransferInstructions from './ETransferInstructions'

import { sendETransferEmail } from '../actions'

const mapDispatchToProps = {
  sendETransferEmail,
}

const mapStateToProps = state => {
  return {
    selectedPaymentPolicies: state.payment.selectedPaymentPolicies,
    isETransfer: state.payment.isETransfer,
    eTransferEmail: state.payment.eTransferEmail,
    eTransferSecret: state.payment.eTransferSecret,
    isETransferEmailInProgress: state.payment.isETransferEmailInProgress,
    sendETransferEmailResponse: state.payment.sendETransferEmailResponse,
    labels: getFromSettings(state, 'labels', {}),
    features: state.appReducer.features,
    subdomain: state.appReducer.settings.subdomain,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ETransferInstructions)
